import {deletePopover} from "../../../hoc/deletePopover";

const CashBoxCashOutDeleteModal = deletePopover("CashBoxCashOutDeleteModal")

export default CashBoxCashOutDeleteModal
